import { routerRedux } from 'dva';
import { notification } from 'antd';
import { list, add, modify } from '../service';

export default {
    namespace: 'user',

    state: {
        userList: {}
    },
    subscriptions: {
        setup({ dispatch, history }) {
            return history.listen(({ pathname, query }) => {
                if (pathname === '/user/list') {
                    dispatch({ type: 'getList', payload: {} });
                }
            });
        }
    },

    effects: {
        *getList({ payload }, { call, put }) {
            try {
                const { code, msg, data } = yield call(list, payload);

                if (code) return false;

                yield put({
                    type: 'setList',
                    payload: data
                });

            } catch (e) {
                console.log(e);
            }
        },
        *addUser({ payload }, { call, put }) {
            try {
                const { code, msg, data } = yield call(add, payload);

                if (code) return false;

                delete payload.password;

                payload._id = data._id;
                payload.can_login = 1;
                payload.type = 2;
                payload.create_time = new Date();
                payload.role = parseInt(payload.role, 10);

                yield put({
                    type: 'setUser',
                    payload: {
                        type: 'add',
                        data: payload
                    }
                });

                return true;

            } catch (e) {
                console.log(e);

                return false;
            }
        },
        *modifyUser({ payload }, { call, put }) {
            try {
                const { code, msg } = yield call(modify, payload);

                if (code) return false;

                delete payload.username;
                delete payload.password;

                yield put({
                    type: 'setUser',
                    payload: {
                        type: 'modify',
                        data: payload
                    }
                });

                return true;

            } catch (e) {
                console.log(e);

                return false;
            }
        }
    },

    reducers: {
        setList(state, { payload }) {
            return {
                ...state,
                userList: payload
            };
        },
        setUser(state, { payload }) {

            let list = state.userList.list;

            if (payload.type == "modify") {

                list = list.map((item) => {

                    if (item._id == payload.data._id) {

                        return {
                            ...item,
                            ...payload.data
                        }
                    }
                    return item;
                });
            }
            else {
                list.push(payload.data);
            }

            return {
                ...state,
                userList: {
                    list: [...list]
                }
            };
        }
    }
};